import React from 'react';

import { PassoExecutado } from '@/models/PassoExecutado';

import IconFotoceutico from '@/assets/fotoceutico-icon.svg';

import { FhirArtefatoType } from '@/features/enterprise/models/types';
import { ItemList, SectionTitle } from './styles';
import ListaFotoceuticosFhir from './index.fhir';
import ListaFotoceuticosDefault from './index.default';

interface ListaFotoceuticosProps {
  fotoceuticos: FhirArtefatoType[];
  passoExecutado: PassoExecutado;
  integracaoEnterpriseAtiva?: boolean;
}

const ListaFotoceuticos: React.FC<ListaFotoceuticosProps> = ({
  fotoceuticos,
  passoExecutado,
  integracaoEnterpriseAtiva,
}) => {
  return (
    <ItemList>
      <SectionTitle>
        <img src={IconFotoceutico} alt="Fotocêutico Icone" />

        <h2>Fotocêuticos sugeridos</h2>
      </SectionTitle>

      {integracaoEnterpriseAtiva ? (
        <ListaFotoceuticosFhir
          fotoceuticos={fotoceuticos}
          passo={passoExecutado}
        />
      ) : (
        <ListaFotoceuticosDefault fotoceuticos={fotoceuticos} />
      )}
    </ItemList>
  );
};

export default ListaFotoceuticos;
